import React from 'react'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import clsx from 'clsx'
import { formatDate } from '@/modules/_helpers/formatDate'
import { DateInput } from '@/modules/base/components/inputs'
import { dispatch } from '@/redux/ducks/lists'
import { updateDocument } from '@/redux/ducks/document/drawer'
import moment from 'moment'
import OCRWrapper from '@/modules/document/components/file-info/ocr-wrapper'
import DocumentReadOnlyField from '@/modules/document/components/file-info/fields/read-only'
import { EXTERNAL_OWNER_SYSTEMS } from '@/modules/file/constants'
import { useAppSelector } from '@/redux/store'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  field: {
    '& div': {
      color: theme.black,
      fontSize: theme.fontSizes.default,
      display: 'flex',
      flexDirection: 'column',
    },
  },
}))

interface DocumentDateInputProps {
  value: string,
  allowEdit?: boolean,
  disabled?: boolean,
  label?: string,
  ocrKey?: string,
  name?: string,
  customClass?: object | string,
  formatter?: { (v: string): string }
  isOcrValue?: boolean
}

const DocumentDateInput = (props: DocumentDateInputProps) => {
  const classes = useStyles()

  const document = useAppSelector((state) => state.document.drawer.document)

  const {
    isAssigned,
    metaData,
    externalOwnerSystem,
  } = document

  const { customClass, label, value, ocrKey, name, disabled, allowEdit, isOcrValue } = props

  if ((isAssigned && !allowEdit) || externalOwnerSystem === EXTERNAL_OWNER_SYSTEMS.desktop) {
    return <DocumentReadOnlyField label={label} formatter={formatDate} value={value} customClass={customClass} />
  }

  return (
    <div className={clsx(classes.field, customClass)}>
      {label ? <label>{label}</label> : null}
      <OCRWrapper isOcrValue={isOcrValue} ocr={metaData?.ocr} ocrKey={ocrKey} valueKey={name} isDate>
        <DateInput
          disableClear={false}
          readOnly={disabled}
          name={name}
          value={value}
          onChange={(v) => dispatch(updateDocument({ key: name, value: moment(v).set('hour', 12).toISOString() }))}
          onBlur={(v) => dispatch(updateDocument({ key: name, value: moment(v).set('hour', 12).toISOString() }))}
        />
      </OCRWrapper>
    </div>
  )
}

export default DocumentDateInput
